import { getBgUrl } from '../utilities/index.js';

var image = document.createElement('img');
if (document.getElementById('hero-banner-0')) {
	let file = getBgUrl(document.getElementById('hero-banner-0'));
	

	if (file != false) {
		image.src = getBgUrl(document.getElementById('hero-banner-0'));
		// console.log('attempt to load image');
		image.onload = function () {
	
			endLoadSequence();
	
		};
	} else {
		// console.log('no image available');
		endLoadSequence();
	}


	function endLoadSequence() {
			document.querySelector(".hero").classList.remove("preload");
			document.querySelector('.load-spinner').classList.add('load-spinner-hide');
			setTimeout(function () {
				document.querySelector('.hero').classList.remove('preload-sub-hero');
			}, 1000)
	
			if (document.getElementById('home-api-nav')) {
				document.getElementById('home-api-nav').classList.add('hero-ready');
			}
	
			if (document.getElementById('hero-banner-0')) {
				document.getElementById('hero-banner-0').classList.add('hero-selected');
			}
	}

}

document.addEventListener('DOMContentLoaded', function() {
	const videoButtons = document.querySelectorAll('.homepage-hero-video-button');
	
	videoButtons.forEach(button => {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			let targetVideo = this.getAttribute('data-video-id');
			const targetElement = document.getElementById(targetVideo);
			if (targetElement) {
				const imgElement = targetElement.querySelector('img');
				if (imgElement && imgElement.parentElement) {
					imgElement.parentElement.click();
				}
			}
		});
	});
});

